import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Icon } from '@types-custom/models/ui/icon-model';

export interface LuminaryStatusUpdate {
  assetId: string;
  status: string;
  icon: Icon;
}

@Injectable({
  providedIn: 'root',
})
export class LuminaryStatusService {
  private statusUpdatesSubject = new Subject<LuminaryStatusUpdate>();
  statusUpdates$ = this.statusUpdatesSubject.asObservable();

  updateStatus(update: LuminaryStatusUpdate): void {
    this.statusUpdatesSubject.next(update);
  }
}
